import { PermissionsUrlCreator } from "src/components/Permissions/PermissionTypes";

export const coursePermissionsUrlCreator: PermissionsUrlCreator =  {
    SetPermissionUrl: () => `/objectpermission/set`,
    DeletePermissionUrl: () => `/objectpermission/delete`,
    GetstartUrl: (itemId:string| number, type:number) => `/objectpermission/get?id=${itemId}&type=${type}`,
    GetSearchUrl: ( type: number, itemId:string,) => `/objectpermission/list/${itemId}/${type}/usersandgroups`
}